<loading [isLoading]="isLoading"></loading>
<div class="panelDetailRoute" [ngClass]="{'expandir': (fullScreen && !mobileQuery.matches)}" *ngIf="isVisible">

  <div class="search-Arrow-flex">
    <div *ngIf="!mobileQuery.matches" style="flex-basis: 10%; text-align: center;">
      <a class="btnReturn" (click)="onClickReturn()" matTooltip="Regresar">
        <mat-icon>arrow_back_ios</mat-icon>
      </a>
    </div>
    <div style="flex-basis: 70%; text-align: center;">
      <h3 style="margin: 0; color: var(--primary-color-dark); font-size: 14px; font-weight: bold;">VIN {{ this.Data.identifier }}</h3>
    </div>
    <div *ngIf="!mobileQuery.matches && !fullScreen" (click)="fullScreen = !fullScreen">
      <mat-icon class="mobile-flecha">keyboard_arrow_up</mat-icon>
    </div>
    <div *ngIf="!mobileQuery.matches && fullScreen" (click)="fullScreen = !fullScreen">
      <mat-icon class="mobile-flecha">keyboard_arrow_down</mat-icon>
    </div>
  </div>

  <div class="header_panel">
    <div class="container header-background">
      <img [src]="panelIcon | findUrl" class="header-img" />
    </div>

    <div class="header-level-2">
      <a *ngIf="mobileQuery.matches" class="btnReturn" (click)="onClickReturn()" matTooltip="Regresar">
        <mat-icon>arrow_back_ios</mat-icon>
      </a>

      <div class="header-info">
        <label class="titlePanel vin-title">VIN {{ this.Data.identifier }}</label>
        <label class="subtitlePanel">{{this.Data.description}}</label>
      </div>

      <div class="btnMenuDropdown">
        <div class="tools-buttons-container">
          <div class="tool-button" (click)="isToolButtonPressed = !isToolButtonPressed" matTooltip="Herramientas">
            <img *ngIf="!isToolButtonPressed" [src]="'menu_hamburguesa.svg' | findUrl">
            <img *ngIf="isToolButtonPressed" [src]="'boton_menos_contraer_menu.svg' | findUrl">
          </div>
        </div>
      </div>
    </div>

    <div class="header-level-3">
      <label class="titlePanel">{{this.Data.startDate}} - {{this.Data.endDate}}</label>
    </div>

    <div [@mostrarHerramientas]="isToolButtonPressed?'visible':'hidden'" class="button-tool-list-vertical">
      <app-report-list
        [isRutas]="true"
        [identifier]="this.Data.identifier"
        [isVerticalList]="true">
      </app-report-list>
    </div>

    <mat-tab-group
      [(selectedIndex)]="selectedTabIndex"
      (selectedTabChange)="selectTab($event)"
      id="panelRouteResumeTabContent">
      <mat-tab>
        <ng-template mat-tab-label>
          <label matTooltip="Resumen del Activo" matTooltipPosition="above" id="routeResumeTab">
            <mat-icon class="example-tab-icon">info</mat-icon>
            Resumen
          </label>
        </ng-template>
        <ng-template matTabContent>
          <!-- Segunda sección -->
          <div class="main-data-container">
            <!-- <div class="row text-header">
              <div class="section-header-background">
                <h3>Datos Generales</h3>
              </div>
            </div> -->
            <div class="items-container">
              <div class="row">
                <div class="col-6 item-resume">
                  <p class="property_text">Distancia Recorrida</p>
                  <img class="item-icon" src="/assets/img/distance.png" />
                  <p class="property_value">{{this.Data.distance}}</p>
                </div>
                <div class="col-6 item-resume">
                  <p class="property_text">Velocidad Promedio</p>
                  <img class="item-icon" src="/assets/img/velocity.png" />
                  <p class="property_value">{{this.Data.velocityProm}}</p>
                </div>
                <div class="col-6 item-resume">
                  <p class="property_text">Duración</p>
                  <img class="item-icon" src="/assets/img/time.png" />
                  <p class="property_value">{{this.Data.durationTime}}</p>
                </div>
                <div class="col-6 item-resume">
                  <p class="property_text">Cantidad de Paradas</p>
                  <img class="item-icon" src="/assets/img/stops.png" />
                  <p class="property_value">{{this.Data.cantStops}}</p>
                </div>
              </div>
            </div>

          </div>
        </ng-template>
      </mat-tab>

      <mat-tab>
        <ng-template mat-tab-label>
          <label matTooltip="" matTooltipPosition="above" id="routeResumeStepsTab">
            <mat-icon class="example-tab-icon">alt_route</mat-icon>
            Trazabilidad de Ruta
          </label>
        </ng-template>
        <ng-template matTabContent>
          <panel-detail-routeSteps (detailsCLicked)="onDetailsClicked($event)" id="routeResumeSteps"></panel-detail-routeSteps>
        </ng-template>
      </mat-tab>
    </mat-tab-group>
  </div>
  <div class="">
    <div class="section-footer-background">
    </div>
  </div>
</div>
